import React from 'react'
import { Feed, Icon, Label } from 'semantic-ui-react'
import Avatar from 'Components/Avatar'
import { Link } from 'react-router-dom'
import { Duration } from 'luxon'
import TimeAgo from 'Lib/TimeAgo'
import styles from './ListStyles'

const actionMap = {
  'project.create': ' created project ',
  'project.update': ' updated project ',
  'project.delete': ' deleted project ',
  'video.create': ' uploaded video ',
  'video.update': ' updated video ',
  'video.delete': ' deleted video ',
  'comment.create': ' commented on video ',
  'comment.update': ' updated comment ',
  'comment.delete': ' deleted comment on video ',
}

const paramsMap = {
  'video.create': ' to project ',
  'video.update': ' in project ',
  'video.delete': ' from project ',
  'comment.create': ' on video  ',
  'comment.update': ' on video ',
}

const User = ({ author }) => (
  <Feed.Label>
    <Avatar
      name={author}
      radius={30}
    />
  </Feed.Label>
)

export const ProjectEvent = ({activity: { key, author, trackable, createdAt}}) => {
  return (
    <Feed.Event className={styles.event}>
      <User author={author} />
      <Feed.Content>
        <Feed.Date>
          <span className={styles.timeAgo}>
            {TimeAgo(createdAt)}&nbsp;
          </span>
          <Icon name='file text outline' />
        </Feed.Date>
        <Feed.Summary className={styles.summary}>
          <span className={styles.author}>{author}</span> {actionMap[key]}
          {trackable &&
            <Link to={`/projects/${trackable.id}`}>{trackable.title}</Link>
          }
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
  )
}

export const VideoEvent = ({
  activity: { key, author, trackable, parameters, createdAt}
}) => {
  return (
    <Feed.Event className={styles.event}>
      <User author={author} />
      <Feed.Content>
        <Feed.Date>
          <span className={styles.timeAgo}>
            {TimeAgo(createdAt)}&nbsp;
          </span>
          <Icon name='file video outline' />
        </Feed.Date>
        <Feed.Summary className={styles.summary}>
          <span className={styles.author}>{author}</span> {actionMap[key]}
            <Link to={`/videos/${trackable.id}`}>{trackable.title}</Link>
            {paramsMap[key]}
          { parameters &&
            <Link to={`/projects/${parameters.projectId}`}>
              {parameters.projectTitle}
            </Link>
          }
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
  )
}

export const CommentEvent = ({
  activity: { key, author, trackable, parameters, createdAt}
}) => {
  return (
    <Feed.Event className={styles.event}>
      <User author={author} />
      <Feed.Content>
        <Feed.Date>
          <span className={styles.timeAgo}>
            {TimeAgo(createdAt)}&nbsp;
          </span>
          <Icon name='comment outline' />
        </Feed.Date>
        <Feed.Summary className={styles.summary}>
          <span className={styles.author}>{author}</span> {actionMap[key]}
          { parameters &&
            <React.Fragment>
              <Link to={`/videos/${parameters.videoId}`}>
                {parameters.videoTitle}
              </Link>
              &nbsp; at &nbsp;
              <Label size='tiny'>
                {Duration.fromMillis(trackable.time).toFormat('MM:SS')}
              </Label>
              </React.Fragment>
          }
        </Feed.Summary>
         <Feed.Extra text className={styles.commentBox}>
          <span>{trackable.text}</span>
        </Feed.Extra>
      </Feed.Content>
    </Feed.Event>
  )
}

export const ComponentsMap = {
  Project: ProjectEvent,
  Video: VideoEvent,
  Comment: CommentEvent
}



// WEBPACK FOOTER //
// ./src/Pages/Activities/ActivityPartials.js